import React, { FunctionComponent } from 'react'
import styles from './DifferenceButton.module.sass'
import clsx from 'clsx'
import { StatisticsType } from '../../../../responses/statistics'
import Difference from '../Difference/Difference'
import Skeleton from 'react-loading-skeleton'

export interface DifferenceProps {
    className?: string,
    type: StatisticsType,
    active: boolean,
    value: [number, number]
    onClick: (type: StatisticsType) => void,
    periods?: boolean
    hide?:boolean
}

const DifferenceButton: FunctionComponent<DifferenceProps> = props => {
    return <div className={clsx(styles.button, {[styles.active]: props.active} )}>
        {
            props.hide ?
                <Skeleton className={styles.loading}/> :
                <Difference
                    className={clsx(props.className, styles.difference)}
                    value={props.value}
                    onClick={() => props.onClick(props.type)}
                    periods={props.periods}
                />
        }

    </div>
}

export default DifferenceButton
